import styled from 'styled-components'

export const BodyContainer = styled.div`
  /* min-width: 874px; */
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: center;
`